import bemBlock from '@gik/core/utils/bemBlock';
import { Image } from '@gik/ui/Image';
import React from 'react';

export interface ISituationTileProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode;
  imageUrl: string;
}

export const SituationTileBlockName = 'situation-tile';

export default function SituationTile({ title, imageUrl }: ISituationTileProps): React.ReactElement {
  const bem = bemBlock(SituationTileBlockName);

  return (
    <div className={bem(null, null, 'gik-article')}>
      <Image src={imageUrl} className={bem('image')} />
      <span className={bem('title')}>{title}</span>
    </div>
  );
}
